import EmploymentWrapper from 'features/reactivation/screens/Employment/EmploymentWrapper';
import React from 'react';

export default function ReactivationEmploymentPage() {
  return <EmploymentWrapper />;
}
